export const CARD_WIDTH = {
  SM: 336,
  LG: 360,
  XXL: 302,
};

export const CARD_MARGIN = 16;
